import { render, staticRenderFns } from "./coRightOfWithdrawalForm.vue?vue&type=template&id=1d85890b&scoped=true&"
import script from "./coRightOfWithdrawalForm.vue?vue&type=script&lang=ts&"
export * from "./coRightOfWithdrawalForm.vue?vue&type=script&lang=ts&"
import style0 from "./coRightOfWithdrawalForm.vue?vue&type=style&index=0&id=1d85890b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85890b",
  null
  
)

export default component.exports